module.exports = __webpack_public_path__ + "static/img/ma.3bbcce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/ma.jpg
// module id = U0xd
// module chunks = 21